let html = `<div class="company-start">
    <div class="company-start__left">
        <div class="company-start__icon">
            <img class="company-start__img" />
        </div>
    </div>

    <div class="company-start__right">
        <div class="company-start__name">{name}</div>
        <div class="company-start__place">{place}</div>
    </div>
</div>`

export default html